import { useRedux } from '../modularRedux';
import reducers from './reducers';

export const storeKey = 'app';

export interface AppState {
  loading: boolean;
  shouldShowLoader: boolean;
  submitPlaidLoading: boolean;
  completeOnInit: boolean;
  totalRegSteps: number | null;
  stepNumber: number | null;
  errorCode: number | null;
  error: string | null;
  achError: string | null;
  achMessage: string | null;
  message: string | null;
  questions: any[];
  unresolvedErrors: any[];
  resetKBAFlow: boolean;
  plaidLinkToken: string;
  appOs: string | null;
  appVersion: string | null;
  embeddedWebreg: boolean;
  inAppPreReg: boolean;
  prefilledAnswers: Record<string, any>;
  phoneNumberProvided: boolean;
  shortcut: string;
  shortcutPlan: string;
  proveMobileAuthState: string | null;
  proveRedirectUri: string | null;
  noPhoneNumberPriceText: boolean;
  mockPma: Record<string, any>;
  stargatewayKey: string | null;
  jwt: string | null;
  regAccessToken: string | null;
  registrationToken: string | null;
  voicepinLoading: boolean;
  timeoutError: string | null;
  flowId: string | null;
  groupId: string | null;
  registrationId: string | null;
  totalGroupsInFlow: number | null;
  togglesDirty: boolean;
  answers: Record<string, any> | null;
  braintreeAccessToken: string | null;
  needsVerification: boolean;
  skippedVerification: boolean;
  extras: Record<string, any> | null;
  noPhoneRegEntry: boolean;
  linkSource: string;
  isFirstScreenForReturningUser: boolean;
  showFccPreReg: boolean;
  isKycRetryAttempt: boolean;
  validateResetPasswordTokenComplete: boolean;
  initializeLoading: boolean;
  shouldRefetchServersideToggles: boolean;
  shouldRedirectToExternalBrowser: boolean;
  hasCheckedForLtaRedirectOnLoad: boolean;
  redirectOnError: boolean;
  shouldRedirectToLta: boolean;
  ltaRedirectParams: Record<string, any> | null;
}

export const initialState: AppState = {
  loading: false,
  shouldShowLoader: true,
  submitPlaidLoading: false,
  completeOnInit: false,
  totalRegSteps: null,
  stepNumber: null,
  errorCode: null,
  error: null,
  achError: null,
  achMessage: null,
  message: null,
  questions: [],
  unresolvedErrors: [],
  resetKBAFlow: false,
  plaidLinkToken: '',
  appOs: null,
  appVersion: null,
  embeddedWebreg: false,
  inAppPreReg: false,
  prefilledAnswers: {},
  phoneNumberProvided: false,
  shortcut: '',
  shortcutPlan: '',
  proveMobileAuthState: null,
  proveRedirectUri: null,
  noPhoneNumberPriceText: false,
  mockPma: {
    enabled: false,
    state: null,
    phone: null
  },
  stargatewayKey: null,
  jwt: null,
  regAccessToken: null,
  registrationToken: null,
  voicepinLoading: false,
  timeoutError: null,
  flowId: null,
  groupId: null,
  registrationId: null,
  totalGroupsInFlow: null,
  togglesDirty: true,
  answers: null,
  braintreeAccessToken: null,
  needsVerification: false,
  skippedVerification: false,
  extras: null,
  noPhoneRegEntry: false,
  linkSource: '',
  isFirstScreenForReturningUser: false,
  showFccPreReg: false,
  isKycRetryAttempt: false,
  validateResetPasswordTokenComplete: false,
  initializeLoading: false,
  shouldRefetchServersideToggles: false,
  shouldRedirectToExternalBrowser: false,
  hasCheckedForLtaRedirectOnLoad: false,
  redirectOnError: true,
  shouldRedirectToLta: false,
  ltaRedirectParams: null,
};

export const [useApp, useAppDispatchers, appActions] = useRedux(
  storeKey,
  reducers,
  initialState
);
